// in strings with letters more than our limit, cut letters after out limit adnd replace them with '...'
export function truncateText(string, limit = 50) {
    if (!string) return;
    return string.length <= limit
        ? string
        : string.substring(0, limit) + '...';
}

// in numbers of more than three digits, use a comma after every third digit from right to left.
export function commaNumber(number) {
    if (!number) return;
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// returns the value of a number rounded to the nearest integer.
export function round(number, dimension = 1) {
    if (!number) return;
    return Math.round(number / dimension) * dimension;
}

// returns the largest integer less than or equal to a given number.
export function floor(number, dimension = 1) {
    if (!number) return;
    return Math.floor(number / dimension) * dimension;
}
